const SESSION_CONFIG = {
  admin: {
    accessTokenKey: "admin_access_token",
    refreshTokenKey: "admin_refresh_token",
    userKey: "admin_user",
    loginPath: "/admin-panel/login",
  },
  user: {
    accessTokenKey: "user_access_token",
    refreshTokenKey: "user_refresh_token",
    userKey: "user_data",
    loginPath: "/login",
  },
};

const refreshRequests = {
  admin: null,
  user: null,
};

function getSessionConfig(sessionType) {
  const config = SESSION_CONFIG[sessionType];

  if (!config) {
    throw new Error("Tipo de sesión no válido.");
  }

  return config;
}

function clearSessionStorage(sessionType) {
  const config = getSessionConfig(sessionType);

  localStorage.removeItem(config.accessTokenKey);
  localStorage.removeItem(config.refreshTokenKey);
  localStorage.removeItem(config.userKey);

  if (sessionType === "user") {
    localStorage.removeItem("organization");
  }
}

function notifySessionExpired(sessionType) {
  const config = getSessionConfig(sessionType);

  clearSessionStorage(sessionType);

  window.dispatchEvent(
    new CustomEvent("auth:session-expired", {
      detail: {
        sessionType,
        loginPath: config.loginPath,
        message: "Tu sesión ha expirado. Inicia sesión nuevamente.",
      },
    })
  );
}

async function refreshAccessToken(sessionType) {
  const config = getSessionConfig(sessionType);
  const refreshToken = localStorage.getItem(
    config.refreshTokenKey
  );

  if (!refreshToken) {
    throw new Error("No existe un token de renovación.");
  }

  if (refreshRequests[sessionType]) {
    return refreshRequests[sessionType];
  }

  refreshRequests[sessionType] = fetch(
    "/api/auth/token/refresh/",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        refresh: refreshToken,
      }),
    }
  )
    .then(async (response) => {
      let data = {};

      try {
        data = await response.json();
      } catch {
        data = {};
      }

      if (!response.ok || !data.access) {
        throw new Error(
          data.detail ||
            data.message ||
            "No fue posible renovar la sesión."
        );
      }

      localStorage.setItem(
        config.accessTokenKey,
        data.access
      );

      if (data.refresh) {
        localStorage.setItem(
          config.refreshTokenKey,
          data.refresh
        );
      }

      return data.access;
    })
    .finally(() => {
      refreshRequests[sessionType] = null;
    });

  return refreshRequests[sessionType];
}

function buildHeaders(options, accessToken) {
  const headers = new Headers(options.headers || {});

  headers.set("Authorization", `Bearer ${accessToken}`);

  if (!headers.has("Accept")) {
    headers.set("Accept", "application/json");
  }

  const isFormData =
    typeof FormData !== "undefined" &&
    options.body instanceof FormData;

  if (
    options.body &&
    !isFormData &&
    !headers.has("Content-Type")
  ) {
    headers.set("Content-Type", "application/json");
  }

  return headers;
}

async function executeRequest(
  url,
  options,
  accessToken
) {
  return fetch(url, {
    ...options,
    headers: buildHeaders(options, accessToken),
  });
}

export async function appFetch(
  url,
  options = {},
  sessionType = "user"
) {
  const config = getSessionConfig(sessionType);
  const accessToken = localStorage.getItem(
    config.accessTokenKey
  );

  if (!accessToken) {
    notifySessionExpired(sessionType);
    throw new Error(
      "Tu sesión ha expirado. Inicia sesión nuevamente."
    );
  }

  let response;

  try {
    response = await executeRequest(
      url,
      options,
      accessToken
    );
  } catch {
    throw new Error(
      "No fue posible conectar con el servidor."
    );
  }

  if (response.status !== 401) {
    return response;
  }

  try {
    const newAccessToken =
      await refreshAccessToken(sessionType);

    return await executeRequest(
      url,
      options,
      newAccessToken
    );
  } catch {
    notifySessionExpired(sessionType);

    throw new Error(
      "Tu sesión ha expirado. Inicia sesión nuevamente."
    );
  }
}

export async function appFetchJson(
  url,
  options = {},
  sessionType = "user"
) {
  const response = await appFetch(
    url,
    options,
    sessionType
  );

  let data = {};

  try {
    data = await response.json();
  } catch {
    data = {};
  }

  if (!response.ok) {
    throw new Error(
      data.message ||
        data.detail ||
        "No fue posible completar la solicitud."
    );
  }

  return data;
}

export function clearStoredSession(
  sessionType = "user"
) {
  clearSessionStorage(sessionType);
}

export default appFetch;